/* global wp */
import Notice from './elements/notice'

const { __ } = wp.i18n

const NoAccess = () => {
	return (
		<main className="sui-wrap">
			<Notice style={{ marginBottom: '10px' }}>
				<p>{__('You do not have the permission to view this page.', 'wpmudev')}</p>
			</Notice>
		</main>
	)
}

export default NoAccess
